import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { loadJobTitleOptions } from './actions/load-job-title-options';
import { jobTitlesForOrgIdSelector } from '../job-summary/job-summary-selectors';

import { UiAutocompleteFreeSolo } from '../ui/ui-autocomplete-freeSolo';

import { SORT_ORDER, sortAlphabetically } from '../util/sort-functions';

type InputProps = {
  orgId: number;
  jobTitle: string;
  setJobTitle: (newJobTitle: string) => void;
  jobId: number | null;
  setJobId: (newJobId: number | null) => void;
};

const mapStateToProps = (state: any, { orgId }: InputProps) => ({
  jobTitleSummaries: jobTitlesForOrgIdSelector(state, orgId),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { orgId }: InputProps,
) => ({
  actions: {
    loadJobTitleSummaries: () => dispatch(loadJobTitleOptions(orgId)),
  },
});

type ReduxProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & ReduxProps & DispatchProps;

export const JobTitleAutocomplete = connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: Props) => {
  const { jobTitle, setJobTitle, setJobId, jobTitleSummaries, actions } = props;

  useEffect(() => {
    actions.loadJobTitleSummaries();
  });

  if (!jobTitleSummaries) {
    return null;
  }

  const getJobTitleOptions = () => {
    const jobTitleOptions = (jobTitleSummaries || []).map((jts) => ({
      value: jts.titleCityState,
      label: jts.titleCityState,
    }));

    return jobTitleOptions.sort(sortAlphabetically((val) => val.label, SORT_ORDER.ASC));
  };

  const handleNewJobTitleSelected = (newJobTitle: string) => {
    setJobTitle(newJobTitle);

    const matchingJobTitleSummary = jobTitleSummaries.find(
      (jts) => jts.titleCityState === newJobTitle,
    );
    setJobId(matchingJobTitleSummary?.jobId || null);
  };

  return (
    <div>
      <UiAutocompleteFreeSolo
        value={jobTitle}
        label="Job Title"
        options={getJobTitleOptions()}
        onChange={handleNewJobTitleSelected}
      />
    </div>
  );
});
